export default function trackHeapEvent(
  properties,
  eventName = undefined,
  experiments = undefined
) {
  if (window.heap?.track) {
    const nameEvent = !eventName ? 'CMS_Unification' : eventName;
    window.heap.track(nameEvent, properties);
    if (experiments) {
      window.heap.track('LC_Website_Optimizely_Exp', experiments);
      window.heap.addUserProperties(experiments);
    }
  }
}
